// AG_GRID
import {
  LicenseManager,
  AllCommunityModule,
  AllEnterpriseModule,
  ModuleRegistry,
  provideGlobalGridOptions
} from 'ag-grid-enterprise';
import 'ag-grid-enterprise';
import 'ag-grid-enterprise/styles/ag-grid.css';
import 'ag-grid-enterprise/styles/ag-theme-balham.css';
import '@/assets/ag-theme-custom.css';
LicenseManager.setLicenseKey(
  'DownloadDevTools_COM_NDEwMjM0NTgwMDAwMA==59158b5225400879a12a96634544f5b6'
);
ModuleRegistry.registerModules([AllCommunityModule, AllEnterpriseModule]);
provideGlobalGridOptions({ theme: 'legacy' });

import { createRoot } from 'react-dom/client';
import App from './App';
import Main from './MainProvider';
import ReduxWrapper from './store/ReduxWrapper';
import '@/helpers/utils';
import '@/helpers/initFA';
import '@/assets/customstyles.css';
import { i18setup } from '@/locales/i18n';
import { HelmetProvider } from 'react-helmet-async';

const container = document.getElementById('main');
if (!container) {
  throw new Error('Root element #main not found');
}

const root = createRoot(container);

root.render(
  <ReduxWrapper>
    {i18setup()}
    <HelmetProvider>
      <Main>
        <App />
      </Main>
    </HelmetProvider>
  </ReduxWrapper>
);
